import React, { useMemo } from 'react';
import styled from 'styled-components';
import { items } from 'components/CreateIncident/components/StatusSelect';
import { useComponentStatuses } from 'shared/hooks';
import { useTranslation } from 'react-i18next';
import ComponentsTree from '../../../ComponentTree';

type FormikTreeProps = {
  form: any,
  isPlanned: any
};

const FormikTree = (props: FormikTreeProps) => {
  
  const { form, isPlanned, ...rest } = props;
  const { data: components } = useComponentStatuses();
  const affected_comps = useMemo(
    () => (rest.initialValues ? rest.initialValues.affected_components : null),
    [rest.initialValues.affected_components]
  );
  return (
    <>
      {components ? (
        <ComponentTree
          id="formik_tree"
          value={form.values.affected}
          components={components}
          isPlanned={isPlanned}
          affected_components={affected_comps}
          onChange={v => {
            form.setFieldValue('affected', v);
          }}
        />
      ) : null}
    </>
  );
};
type ComponentTreeProps = {
  affected_components?: any,
  components?: any,
  isPlanned?: boolean,
  onChange?: () => void
};

const ComponentTree = (props: ComponentTreeProps) => {
  const { components, onChange, isPlanned, affected_components } = props;
  const { t } = useTranslation();
  const memoedStatusOptions = useMemo(
    () =>
      isPlanned
        ? items.filter(i => i.id === 'UM')
        : items.filter(i => i.id !== 'UM'),
    [isPlanned]
  );
  return (
    <StyledTreeContainer>
      <ComponentsTree
        initialSelectedComponents={affected_components}
        overrideComponentStatus
        actionCallback={compObj => {
          let affectedComponents = Object.keys(compObj).filter(
            eachComponent => compObj[eachComponent].selected
          );
          affectedComponents = affectedComponents.map(eachComponent => ({
            component: String(compObj[eachComponent].component),
            new_status: compObj[eachComponent].status
          }));
          onChange(affectedComponents);
        }}
        components={components}
        isPlanned={isPlanned}
        title={t('components.createIncident.selectAffectedServices')}
        statusOptions={memoedStatusOptions}
      />
    </StyledTreeContainer>
  );
};

ComponentTree.defaultProps = {
  affected_components: [],
  components: [],
  onChange: () => undefined
};

const StyledTreeContainer = styled.div`
  max-height: 100%;
  overflow: visible;
  width: 100%;
  display: flex;
  margin-bottom: 20px;
  .title {
    font-weight: 500;
    font-size: 12px;
    color: #183247;
    line-height: 1.6;
  }
`;
export default FormikTree;
